import React, { createContext, useContext, useEffect, useState } from "react";
import Api from "../Services/Api";


const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = (userData) => setUser(userData);

  const logout = async () => {
    await Api.post("/logout");
    setUser(null);
  };

  useEffect(() => {
    const loadSession = async () => {
      try {
        const res = await Api.get("/auth/me");
        if (res.data.ok) setUser(res.data.user);
      } catch (e) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    loadSession();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
